import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { constants } from '../shared/constants/constants';
import { BaseService } from './base-service';
import { Url } from '../lib/Url';
import { UserService } from './user.service';
import { ApplicationService } from './application.service';

@Injectable({
    providedIn: 'root',
})
export class PowerCheckerService extends BaseService {
    private timerSub: Subscription = null;

    constructor(
        protected http: HttpClient,
        protected auth: ApiService,
        protected user: UserService,
        private application: ApplicationService
    ) {
        super(http, auth, user);
    }

    destroy(): void {
        super.destroy();
        if (this.timerSub) {
            this.timerSub.unsubscribe();
            delete this.timerSub;
        }
    }

    /**
     * Request the currently saved powerchecker state from the API
     */
    getState(): Observable<any> {
        let url = this.API_BASE_URL + constants.api.routes.plug.relay;
        if (this.application.isDemoMode()) {
            url = `assets/data/demo/${constants.demo.files.plugRelay}.json`;
        }
        return this.http.get(url).pipe(
            mergeMap((res: { status: string; data: any }) => of(this.mapDefault(res))),
            mergeMap((mapped) => {
                if (this.validateStateResponse(mapped)) {
                    return of(mapped);
                }
                return throwError({ msg: 'Faulty getState response after inital validation' });
            }),
            catchError((e) => this.handleError(e))
        );
    }

    setState(value): Observable<any> {
        const url = new Url(null);
        url.push(this.API_BASE_URL);
        url.push(constants.api.routes.plug.relay);

        const payload = { on_off: value };

        return this.http.put(url.toString(), payload).pipe(
            mergeMap((res: { status: string; message: string }) => {
                if (this.validateSetStateResponse(res)) {
                    return of(res.status === 'ok' && res.message === 'ok');
                }
                return throwError({ msg: 'Faulty setState response after initial validation.' });
            }),
            catchError((e) => {
                return this.handleError(e);
            })
        );
    }

    private validateSetStateResponse(response: any): boolean {
        const status = 'status' in response;
        const msg = 'message' in response;
        return status && msg;
    }

    private validateStateResponse(response: any): boolean {
        if ('relay' in response) {
            if ('on_off' in response.relay) {
                return true;
            }
        }
        return false;
    }
}
